"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

interface ModalPorps {
  children: React.ReactNode;
  isOpen: boolean;
  title?: string;
  handleClose: () => void;
}

const Modal = ({ children, isOpen, title, handleClose }: ModalPorps) => {
  const router = useRouter();
  useEffect(() => {
    const closeOnEscapeKey = (e: KeyboardEvent) =>
      e.key === "Escape" ? handleClose() : null;

    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => document.body.removeEventListener("keydown", closeOnEscapeKey);
  }, [handleClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("fixed");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("fixed");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("fixed");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="flex flex-col w-screen h-screen absolute top-0 left-0 z-40 bg-white items-center px-5">
      <div className="flex flex-row justify-between  w-full py-[14px] ">
        <h1 className="font-bold text-[20px]">{title ? title : "Фильтры"}</h1>
        <button onClick={handleClose}>
          <Image
            src={"/ui/closeIcon.svg"}
            width={28}
            height={28}
            alt="Close"
            className="w-4 h-4"
          />
        </button>
      </div>

      <div className="w-full  h-screen overflow-y-scroll ">{children}</div>
    </div>
  );
};

export default Modal;
